import ownershipKyc from "../models/ownership-kyc";

export const types = {
  OWNERSHIP_KYC_REQUEST: "OWNERSHIP_KYC_REQUESTED",
  OWNERSHIP_KYC_DATA: "OWNERSHIP_KYC_DATA",
  OWNERSHIP_KYC_SUCCESS: "OWNERSHIP_KYC_SUCCESS",
  OWNERSHIP_KYC_DATA_SUCCESS: "OWNERSHIP_KYC_DATA_SUCCESS",
  OWNERSHIP_KYC_FAILED: "OWNERSHIP_KYC_FAILED",
  OWNERSHIP_KYC_SUBMIT_REQUEST: "OWNERSHIP_KYC_SUBMITTED",
  OWNERSHIP_KYC_SUBMIT_SUCCESS: "OWNERSHIP_KYC_SUBMIT_SUCCESS",
  OWNERSHIP_KYC_SUBMIT_FAILED: "OWNERSHIP_KYC_SUBMIT_FAILED",
  OWNERSHIP_KYC_FORM_RESET: "OWNERSHIP_KYC_FORM_RESET",
  OWNERSHIP_KYC_PUBLISH: "OWNERSHIP_KYC_PUBLISH",
  OWNERSHIP_KYC_PUBLISH_SUCCESS: "OWNERSHIP_KYC_PUBLISH_SUCCESS",
  OWNERSHIP_KYC_PUBLISH_FAILED: "OWNERSHIP_KYC_PUBLISH_FAILED",
  OWNERSHIP_KYC_LINKING: "OWNERSHIP_KYC_LINKING",
  OWNERSHIP_KYC_LINKING_SUCCESS: "OWNERSHIP_KYC_LINKING_SUCCESS",
  OWNERSHIP_KYC_LINKING_FAILED: "OWNERSHIP_KYC_LINKING_FAILED",
  OWNERSHIP_KYC_REMOVE: "OWNERSHIP_KYC_REMOVE",
  OWNERSHIP_KYC_REMOVE_SUCCESS: "OWNERSHIP_KYC_REMOVE_SUCCESS",
  OWNERSHIP_KYC_REMOVE_FAILED: "OWNERSHIP_KYC_REMOVE_FAILED",
  OWNERSHIP_KYC_SUBMIT: 'OWNERSHIP_KYC_SUBMIT',
};

export const actions = {
  ownershipKycSubmitForm: (payload, setLoading, setData) => {
    return { type: types.OWNERSHIP_KYC_SUBMIT, value: payload, setLoading, setData };
  },
  ownershipKycGet: (payload) => {
    return { type: types.OWNERSHIP_KYC_REQUEST, value: payload };
  },
  ownershipKycDataGet: (payload) => {
    return { type: types.OWNERSHIP_KYC_DATA, value: payload };
  },
  ownershipKycSubmit: (payload, callback = () => { }) => {
    return { type: types.OWNERSHIP_KYC_SUBMIT_REQUEST, value: payload, callback };
  },
  ownershipKycFormReset: (payload) => {
    return { type: types.OWNERSHIP_KYC_FORM_RESET, value: payload };
  },
  ownershipKycPublish: (values, callback = () => { }) => {
    return { type: types.OWNERSHIP_KYC_PUBLISH, value: values, callback };
  },
  ownershipKycLinking: (payload) => {
    return { type: types.OWNERSHIP_KYC_LINKING, value: payload };
  },
  ownershipKycRemove: (payload, callback = () => { }) => {
    return { type: types.OWNERSHIP_KYC_REMOVE, value: payload, callback };
  },
};

function setViewConfig(value) {
  try {
    const { data } = value[Object.keys(value)[0]];

    if (!data) {
      return {};
    }

    return {
      title: {
        en: data.name,
        fr: data.name,
      },
    }
  } catch (err) {
    return {};
  }
}

const reducer = (state = ownershipKyc, action) => {
  const { data = {} } = state;
  switch (action.type) {
    case types.OWNERSHIP_KYC_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case types.OWNERSHIP_KYC_SUCCESS:
      return {
        ...state,
        loading: false,
        retrived: true,
        data: {
          ...data,
          ...action.value,
        }
      }
    case types.OWNERSHIP_KYC_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        retrived: true,
        data: {
          ...data,
          ...action.value,
        },
        viewConfig: {
          ...setViewConfig(action.value),
        },
      }
    case types.OWNERSHIP_KYC_SUBMIT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.OWNERSHIP_KYC_SUBMIT_SUCCESS:
      if (!data[`${action.value.module}-${action.value.view}`]) {
        data[`${action.value.module}-${action.value.view}`] = {}
      }
      data[`${action.value.module}-${action.value.view}`].data = action.value;
      return {
        ...state,
        loading: false,
        retrived: true,
        data: {
          ...data,
        },
        viewConfig: {
          ...setViewConfig(data),
          ...setViewConfig({ 'tif-ownership-kyc': { data: action.value } }),
        },
      };
    case types.OWNERSHIP_KYC_LINKING_SUCCESS:
      state.data.linking = action.value;
      return {
        ...state,
        data: {
          ...state.data,
        },
        loading: false,
      };
    case types.OWNERSHIP_KYC_FORM_RESET:
      delete state.data[`${action.value.module}-${action.value.view}`];
      return {
        ...state,
        data: {
          ...state.data,
        },
        loading: false,
      };
    case types.OWNERSHIP_KYC_SUBMIT_FAILED:
      return {
        ...state,
        loading: false,
        errors: action.value || null,
      };
    case types.OWNERSHIP_KYC_PUBLISH_SUCCESS:
      const { module: modu, view: vie, ...fData } = action.value;
      state.data[`${modu}-${vie}`].data = fData;
      return {
        ...state,
        data: {
          ...state.data,
        },
        loading: false,
      };
    case types.OWNERSHIP_KYC_PUBLISH_FAILED:
      return {
        ...state,
        loading: false,
        errors: action.value || null
      };
    default:
      return state;
  }
};

export default reducer;
